import React, { useMemo } from "react";
import classes from "./StakingTotalRewardsStyles.module.scss";
import { Link } from "react-router-dom";
import { OutgoingLinks } from "../../config/links";
import { ActionButton } from "../Buttons/ActionButton/ActionButton";
import { CoinBalance } from "./types";
import { createBalancesGraph } from "./utils";
import { uniqueId } from "lodash";
import ThunderImage from "./images/thunder-min.png";
import { Trans } from "@lingui/macro";
import { UseBreakpoints } from "../../hooks/useBreakpoints";

type Props = {
  totalBalance: string;
  onCompoundClick: () => void;
  onClaimClick: () => void;
  coinsBalances: CoinBalance[];
  multiplierPoints: string;
  stakedMultiplierPoints: string;
  isAuthorized: boolean;
  connectWallet: () => void;
};
export const StakingTotalRewards = ({
  totalBalance,
  onCompoundClick,
  onClaimClick,
  coinsBalances,
  multiplierPoints,
  stakedMultiplierPoints,
  isAuthorized,
  connectWallet,
}: Props) => {
  const graphStates = createBalancesGraph(coinsBalances);
  const { isMobile } = UseBreakpoints();

  return (
    <section className={classes.component}>
      <div className={classes.wrapper}>
        <div className={classes.headerWrapper}>
          <h2 className={classes.title}>Total Rewards</h2>
          {!isMobile && (
            <div className={classes.disclimerWrapper}>
              <img src={ThunderImage} alt="" className="" width={32} height={32} />
              <span className={classes.disclimerText}>Want to learn how compounding works?</span>
              <a className={classes.link} href={"https://cadenceprotocol.gitbook.io/cadence-protocol/achievements-and-rewards/vesting-rewards"}>
                Learn more
              </a>
            </div>
          )}
        </div>
        <div className={classes.rewardsContent}>
          <span className={classes.balance}>{totalBalance}</span>

          <div className={classes.buttonsWrapper}>
            <ActionButton
              className={classes.compoundStyles}
              onClick={isAuthorized ? onCompoundClick : connectWallet}
              type={"outlined"}
              buttonText={<Trans>Compound</Trans>}
            />
            <ActionButton
              onClick={isAuthorized ? onClaimClick : connectWallet}
              type={"grey"}
              buttonText={
                <>
                  <Trans>Claim</Trans>
                </>
              }
            />
          </div>
        </div>
        {isMobile && (
          <div className={classes.statesGraph}>
            {graphStates &&
              graphStates.map((graph) => (
                <div
                  key={uniqueId(graph.percentFromTotal)}
                  className={classes.graphItem}
                  style={{
                    width: `${graph.percentFromTotal}%`,
                    background: graph.color,
                    boxShadow: `0 2px 30px -0.5px ${graph.color}`,
                  }}
                ></div>
              ))}
          </div>
        )}
        <div className={classes.balanceInfoWrapper}>
          <div className={classes.balances}>
            {coinsBalances.map((coinBalance) => (
              <div key={uniqueId(coinBalance.title)} className={classes.balanceItem}>
                <div className={classes.coinBalanceNameWrapper}>
                  <div className={classes.coinBalanceColorIcon} style={{ background: coinBalance.color }}></div>
                  {coinBalance.title}
                </div>
                <span className={classes.coinBalance}>{coinBalance.balance}</span>
                <span className={classes.coinBalanceUsd}>{coinBalance.balanceUsd}</span>
              </div>
            ))}
          </div>
          <div className={classes.pointsWrapper}>
            <div className={classes.pointWrapper}>
              <span className={classes.pointTitle}>Multiplier points</span>
              <span className={classes.pointValue}>{multiplierPoints}</span>
            </div>
            <div className={classes.pointWrapper}>
              <span className={classes.pointTitle}>Staked Multiplier points</span>
              <span className={classes.pointValue}>{stakedMultiplierPoints}</span>
            </div>
          </div>
        </div>

        {isMobile && (
          <div className={classes.disclimerWrapper}>
            <img src={ThunderImage} alt="" className="" width={32} height={32} />
            <span className={classes.disclimerText}>Want to know how to get maximum yield ?</span>
            <a className={classes.link} href={OutgoingLinks.YIELD_LEARN_MORE}>
              Learn more
            </a>
          </div>
        )}
      </div>
      {!isMobile && (
        <div className={classes.statesGraph}>
          {graphStates &&
            graphStates.map((graph) => (
              <div
                key={uniqueId(graph.percentFromTotal)}
                className={classes.graphItem}
                style={{
                  width: `${graph.percentFromTotal}%`,
                  background: graph.color,
                  boxShadow: `0 2px 30px -0.5px ${graph.color}`,
                }}
              ></div>
            ))}
        </div>
      )}
    </section>
  );
};
